{{!--
On local, "primary_color" and "secondary_color" come from app/local-data/customizations.json. Otherwise, these values
come from Foundry.
To view whitelabeling locally, add "cssTemplate": "styles/custom" to app/course-settings.json.
--}}

#site-container {
  --on-primary: #ffffff;
  --on-secondary: #000000;
  --neutral: #e0e0e0;
}

{{#if primary_color}}

#site-container .bg-color-brand-primary,
#site-container .bg-color-interactive-500,
#site-container .bg-color-interactive-700 {
  background-color: {{primary_color}} !important;
}

#site-container .font-color-brand-primary,
#site-container .font-color-brand-primary > *,
#site-container .font-color-interactive-500,
#site-container .font-color-interactive-500 > * {
  color: {{primary_color}} !important;
}
#site-container .border-color-brand-primary {
  border-color: {{primary_color}} !important;
}

.branding-primary {
  fill: {{primary_color}};
  color: {{primary_color}};
}


{{!-- Saving this for later, there's a CSS bug that changes the stacking index when a filter is applied, so this causes positioned elements to break (ie. card game, flip cards) --}}

{{!-- #site-container .btn-primary:hover,
#site-container .btn-secondary:hover,
#site-container .btn-tertiary:hover,
#site-container .btn-primary:focus,
#site-container .btn-secondary:focus,
#site-container .btn-tertiary:focus {
  filter: brightness(0.9) saturate(0.6) !important;
} --}} 

{{!-- Primary elements get primary bg + white text --}}
#site-container .btn-primary:not(.disabled):not(:disabled),
#site-container .btn-secondary:not(.disabled):not(:disabled):hover,
#site-container .btn-hotspot,
#site-container .choices__custom-btn-as-input:not(:disabled).choices__input--checked,
#site-container .accordion__bellow.visited .accordion__bullet-step,
#site-container .hotspot-container .hotspot:not(.clicked),
#site-container .module-container .course-hub-module-progress-bar,
#site-container .progression__bar,
#site-container .navigation-bar .navbar,
#site-container .label__theme--primary {
background: {{primary_color}} !important;
color: var(--on-primary) !important;
}

.progression__circle--progress {
  stroke: {{primary_color}} !important;
}

{{!-- Secondary elements get white bg + primary text/borders --}}
.accordion__bullet-step,
#site-container .btn-secondary:not(.disabled):not(:disabled),
#site-container .btn-primary:not(.disabled):not(:disabled):hover,
#site-container .choices__custom-btn-as-input:not(:disabled),
#site-container .label__theme--secondary,
#site-container .timeline__event__dot,
#site-container .drag-and-drop .draggable:hover,
#site-container .range-sliders input[type=range]::-webkit-slider-thumb,
#site-container .input-range-wrapper input[type=range]::-webkit-slider-thumb {
  background-color: var(--on-primary) !important;
  color: {{primary_color}} !important;
  border-color: {{primary_color}} !important;
}

#site-container .choices__label:hover .choices__custom-input-radio,
#site-container .choices__label:hover .choices__custom-input-checkbox,
#site-container .choices--choice-card .choices__label:hover,
#site-container .choices--choice-card .choices__label:active,
#site-container .choices--choice-card .choices__label--checked,
#site-container .field:hover,
#site-container .field:active,
#site-container .field:focus,
#site-container .tabs__tab-bar-button:hover,
#site-container .tabs__tab-bar-button:focus,
#site-container .tabs__tab-bar-button:active,
#site-container .tabs__tab-bar-button--active,
#site-container .callout--generic {
  border-color: {{primary_color}} !important;
}

#site-container .choices__label--checked:not(.choices__label--disabled) .choices__custom-input-radio,
#site-container .choices__label--checked:not(.choices__label--disabled) .choices__custom-input-checkbox,
#site-container .choices__label--checked:hover .choices__custom-input-radio,
#site-container .choices__label--checked:hover .choices__custom-input-checkbox {
  background-color: {{primary_color}} !important;
  border-color: {{primary_color}} !important;
  box-shadow: inset 0 0 0 4px {{primary_color}} !important;
}

#site-container .choices__label--checked .choices__custom-input-toggle {
  background-color: {{primary_color}} !important;
  color: {{primary_color}} !important;
}

#site-container .choices__label:hover .choices__custom-input-radio,
#site-container .choices__label:hover .choices__custom-input-checkbox,
#site-container .choices--choice-card .choices__label:hover,
#site-container .choices--choice-card .choices__label:active,
#site-container .choices--choice-card .choices__label--checked,
#site-container .field:hover,
#site-container .tabs.tab-card .tabs__tab-bar-button:hover,
#site-container .tabs.tab-card .tabs__tab-bar-button--hover {
    box-shadow: inset 0 0 0 1px {{primary_color}} !important;
}

#site-container .tabs.tab-card .tabs__tab-bar-button--active,
#site-container .tabs.tab-card .tabs__tab-bar-button:focus,
#site-container .field:active,
#site-container .field:focus,
#site-container .choices--choice-card .choices__label:active,
#site-container .choices--choice-card .choices__label--checked {
  box-shadow: inset 0 0 0 2px {{primary_color}} !important;
}

#site-container .tabs__tab-bar-button:hover, .tabs__tab-bar-button--hover {
  box-shadow: inset 0 -2px 0 0 {{primary_color}} !important;
}

#site-container .tabs__tab-bar-button:active,
#site-container .tabs__tab-bar-button--active,
#site-container .tabs__tab-bar-button:focus,
#site-container .tabs__tab-bar-button--focus {
  box-shadow: inset 0 -4px 0 0 {{primary_color}} !important;
}


#site-container .btn-navbar,
#site-container .choices__label--checked .choices__custom-input-checkbox > span {
  color: var(--on-primary) !important;
}

#site-container .callout--generic,
#site-container .choices__label--checked .choices__custom-input-radio::after {
  background-color: var(--on-primary) !important;
}

{{!-- Change color only --}}

{{!-- No '!important' for unstyled links so it doesn't override any classes --}}
#site-container a,
#site-container a:hover {
  color: {{primary_color}};
}

#site-container p > a,
#site-container p > a:visited,
#site-container .link,
#site-container .link:visited,
#site-container .link .link__text,
#site-container .links a,
#site-container .links a:visited,
#site-container .activities .activity__link--active,
#site-container .activities .activity__list__item--enabled,
#site-container .activities .activity__list__item--active,
#site-container .btn-tertiary:not(.disabled):not(:disabled),
#site-container .accordion__chevron-icon,
#site-container .range-slider__step,
#site-container .bellow__icon-secondary
#site-container .timeline__interval__dot,
#site-container .callout--generic .callout__icon svg,
#site-container .activities .activity__list__item--active svg,
#site-container .flipcard-container .flipcard__face__arrow-icon div {
  color: {{primary_color}} !important;
}

#site-container .video__container .seek__container .seekbar--play,
#site-container .audio__progress--play {
  background-color: {{primary_color}} !important;
}

{{!-- Grey hover states --}}
#site-container .bg-color-interactive-100,
#site-container .bg-color-interactive-200,
#site-container .bg-color-interactive-300,
#site-container p > a:focus,
#site-container .link:focus,
#site-container .link:focus .link__text,
#site-container .link:hover,
#site-container .link:hover .link__text,
#site-container .activities .activity__list__item--enabled:hover,
#site-container .activities .activity__list__item--active,
#site-container .activity a:focus,
#site-container .choices__label:hover,
#site-container .choices__label:focus,
#site-container .choices__label:focus-within,
#site-container .choices__label:active,
#site-container .choices--choice-card .choices__label:active,
#site-container .choices--choice-card .choices__label--checked,
#site-container .choices--choice-card .choices__label:focus,
#site-container .choices--choice-card .choices__label--focus,
#site-container .choices--choice-card .choices__label:hover,
#site-container .choices--choice-card .choices__label--hover,
#site-container .accordion__bellows:not(.accordion--stepper) .accordion__bellow:hover,
#site-container .accordion__bellows:not(.accordion--stepper) .accordion__bellow-button:hover,
#site-container .accordion__bellows:not(.accordion--stepper) .accordion__bellow-button:focus,
#site-container .accordion__bellows:not(.accordion--stepper) .accordion__bellow.active,
#site-container .accordion__bellows:not(.accordion--stepper) .accordion__bellow-section.active,
#site-container .tabs__tab-bar-button:hover,
#site-container .tabs__tab-bar-button:active,
#site-container .tabs__tab-bar-button--active,
#site-container .btn-tertiary:active,
#site-container .btn-tertiary:focus {
  background-color: var(--neutral) !important;
}

{{/if}}

{{#if secondary_color}}

{{!-- if there's a secondary color, use secondary for Achieve's SVGs instead of primary --}}
.branding-primary {
fill: {{secondary_color}} !important;
}

#site-container .bg-color-brand-secondary {
background-color: {{secondary_color}} !important;
}
#site-container .font-color-brand-secondary,
#site-container .font-color-brand-secondary > * {
color: {{secondary_color}} !important;
}
#site-container .border-color-brand-secondary {
border-color: {{secondary_color}} !important;
}

.branding-secondary {
background: {{secondary_color}} !important;
color: {{primary_color}};
fill: {{secondary_color}} !important;
}

{{/if}}